<div class="section" *ngIf="hasContent || editModeSet">
  <div class="section__header">
    <h2 class="section__header-text">Fuel Providers
      <mat-icon (click)="openEditRentalsDialog(['Fuel::Providers::'], null , 'Fuel Providers')" *ngIf="editModeSet && !isRegionalManager"
                class="edit-icon">edit</mat-icon>
    </h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <div class="data-block__value">
        <app-tag-bullet-list *ngIf="fuelProviderTags && fuelProviderTags.length" [items]="fuelProviderTags"></app-tag-bullet-list>
        <div *ngIf="(editModeSet && !isRegionalManager) && !fuelProviderTags.length">
          <p>None Selected</p>
        </div>
      </div>
    </div>
  </div>
</div>
